export type SubmenuListComponentProps = {
    /** Identifikátory otevřených podmenu */
    submenuIds: readonly number[];
};
